import React, { useState } from 'react';
import { Button, Chip, Menu, MenuItem, Stack, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

/**
 * Inline role editor on each IAM table row.
 *
 * Owners are non-editable — the owner role can't be removed (only granted
 * via a different flow) so we hide the +/- controls when `isOwner` is true.
 * Picking a role is additive: the menu doesn't close on select so users
 * can grant multiple roles in one open.
 */
export default function MemberRoleSelector({ selected, onChange, availableRoles, isOwner }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleToggle = (roleName) => {
    if (selected.includes(roleName)) onChange(selected.filter((r) => r !== roleName));
    else onChange([...selected, roleName]);
  };

  return (
    <Stack direction='row' spacing='6px' flexWrap='wrap' useFlexGap>
      {selected.length === 0 && (
        <Typography variant='caption' color='text.secondary'>No roles</Typography>
      )}
      {selected.map((r) => (
        <Chip
          key={r}
          size='small'
          label={r}
          color={r === 'owner' ? 'secondary' : 'primary'}
          onDelete={isOwner ? undefined : () => handleToggle(r)}
        />
      ))}
      {!isOwner && (
        <>
          <Button
            size='small'
            endIcon={<KeyboardArrowDownIcon />}
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            + Add role
          </Button>
          <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
            {(availableRoles || [])
              .filter((r) => r.role !== 'owner')
              .map((r) => (
                <MenuItem
                  key={r.role}
                  selected={selected.includes(r.role)}
                  onClick={() => { handleToggle(r.role); /* keep menu open */ }}
                >
                  <Typography variant='body2'>{r.role}</Typography>
                </MenuItem>
              ))}
          </Menu>
        </>
      )}
    </Stack>
  );
}
